import {
  ContainerPictures,
  ContainerContentDialog,
} from "./ContentDialogStyle";

const ContentDialog = ({
  pictures,
  event,
  typeEventMedia,
  setTypeEventMedia,
}) => {
  const setTypeMediaHandler = (e) => {
    setTypeEventMedia(e.target.value);
  };

  return (
    <ContainerContentDialog>
      <h3>Are you sure you want to save these pictures ?</h3>
      <ContainerPictures>
        {pictures.map((photo, index) => (
          <img key={index} src={photo} alt={photo} />
        ))}
      </ContainerPictures>
      {typeEventMedia && event?.fieldsCaptureMedia?.length > 0 && (
        <div className="select-type">
          <h3>Please select the type of picture to upload:</h3>
          <select
            className="select"
            value={typeEventMedia}
            onChange={setTypeMediaHandler}
          >
            {event?.fieldsCaptureMedia.map((item) => (
              <option key={item.name} value={item.name}>
                {item.alias}
              </option>
            ))}
          </select>
        </div>
      )}
    </ContainerContentDialog>
  );
};

export default ContentDialog;
